import React from "react";
import { useAccordion } from "../../hooks/lib/useAccordion";
import { IFaqsData } from "../../exports/interfaces";

export const FaqAll = ({
  englishFaqs,
  nepaliFaqs,
}: {
  englishFaqs: IFaqsData[];
  nepaliFaqs: IFaqsData[];
}) => {
  useAccordion(englishFaqs, nepaliFaqs);

  const linkify = (text: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(
      urlRegex,
      (url) =>
        `<a href="${url}" target="_blank" rel="noopener noreferrer" style="text-decoration: underline;">${url}</a>`,
    );
  };
  return (
    <>
      <div className="td_height_120 td_height_lg_40" />

      <div className="td_faq_1 td_style_1 td_type_1">
        <div className="td_faq_1_right">
          {/* <div className="td_accordians td_style_1 td_type_2 td_mb_40"> */}
          <div className="td_accordians td_style_1 td_type_2">
            {englishFaqs.map((faq) => (
              <div className="td_accordian" key={faq.id}>
                <div className="td_accordian_head">
                  <p
                    className="td_accordian_title td_fs_18 fw-bold"
                    dangerouslySetInnerHTML={{
                      __html: faq.question,
                    }}
                  />
                  <span className="td_accordian_toggle"></span>
                </div>
                <div className="td_accordian_body td_fs_18">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: linkify(faq.answer),
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="td_height_120 td_height_lg_40" />

      {/* <div className="td_faq_1 td_style_1">
        <div className="td_faq_1_right">
          <div className="td_accordians td_style_1 td_type_2">
            {nepaliFaqs.map((faq, index) => (
              <div className="td_accordian" key={faq.id}>
                <div className="td_accordian_head">
                  <h2
                    className="td_accordian_title td_fs_24"
                    dangerouslySetInnerHTML={{
                      __html: faq.question,
                    }}
                  />
                  <span className="td_accordian_toggle"></span>
                </div>
                <div className="td_accordian_body td_fs_18">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: faq.answer,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="td_height_120 td_height_lg_80" /> */}
    </>
  );
};
